import { Button } from "@windmill/react-ui";
import React from "react";
import LogoutBtn from "../common/LogoutBtn";
import Logo from "../logo/Logo";

export default function WelcomeScreen({ setStep }) {
  return (
    <div className="p-6 lg:p-0 bg-green-50 min-h-screen">
      <div className="flex justify-between items-center lg:mx-24 mt-4 mb-2">
        <Logo />
        <LogoutBtn />
      </div>
      <div className="flex flex-col justify-between max-w-xl mx-auto">
        <div className="text-center">
          {/* SVG Animation replacing the image */}
          <div className="flex text-lg lg:w-8/12 justify-center mx-auto mb-8 lg:mb-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 800 800"
              width="100%"
              height="100%"
            >
              <g transform="translate(400, 400)">
                <circle
                  cx="0"
                  cy="0"
                  r="320"
                  fill="none"
                  stroke="#e5e7eb"
                  stroke-width="1"
                  stroke-dasharray="3,3"
                  opacity="0.4"
                />
                <circle
                  cx="0"
                  cy="0"
                  r="240"
                  fill="none"
                  stroke="#e5e7eb"
                  stroke-width="1"
                  stroke-dasharray="3,3"
                  opacity="0.5"
                />
                <circle
                  cx="0"
                  cy="0"
                  r="160"
                  fill="none"
                  stroke="#e5e7eb"
                  stroke-width="1"
                  stroke-dasharray="3,3"
                  opacity="0.6"
                />
              </g>

              <g transform="translate(400, 400)">
                <g>
                  <ellipse cx="0" cy="35" rx="45" ry="15" fill="#2563eb" />
                  <rect x="-45" y="0" width="90" height="35" fill="#2563eb" />
                  <ellipse cx="0" cy="0" rx="45" ry="15" fill="#3b82f6" />
                  <ellipse cx="-8" cy="0" rx="30" ry="8" fill="#60a5fa" />
                </g>

                <rect
                  x="-25"
                  y="10"
                  width="50"
                  height="2"
                  fill="#dbeafe"
                  rx="1"
                />
                <rect
                  x="-25"
                  y="16"
                  width="50"
                  height="2"
                  fill="#dbeafe"
                  rx="1"
                />
                <rect
                  x="-25"
                  y="22"
                  width="50"
                  height="2"
                  fill="#dbeafe"
                  rx="1"
                />

                <g transform="translate(0, -25) scale(0.8)">
                  <path
                    d="M0,-35 Q-45,-30 -45,5 Q-45,40 0,45 Q45,40 45,5 Q45,-30 0,-35 Z"
                    fill="#6366f1"
                    fill-opacity="0.75"
                    stroke="#4f46e5"
                    stroke-width="1.5"
                  />

                  <path
                    d="M-30,-20 L-30,-10 L-20,-10 L-20,0 L-10,0 L-10,10 L0,10 L0,20 L10,20"
                    fill="none"
                    stroke="#c7d2fe"
                    stroke-width="1.5"
                  />
                  <path
                    d="M30,-20 L30,-10 L20,-10 L20,0 L10,0 L10,10"
                    fill="none"
                    stroke="#c7d2fe"
                    stroke-width="1.5"
                  />
                  <path
                    d="M-20,-25 L-10,-25 L-10,-15 L0,-15 L0,-5 L10,-5"
                    fill="none"
                    stroke="#c7d2fe"
                    stroke-width="1.5"
                  />

                  <circle cx="-25" cy="-10" r="4" fill="#e0e7ff" />
                  <circle cx="-10" cy="5" r="4" fill="#e0e7ff" />
                  <circle cx="15" cy="-5" r="4" fill="#e0e7ff" />
                  <circle cx="25" cy="15" r="4" fill="#e0e7ff" />
                  <circle cx="0" cy="25" r="4" fill="#e0e7ff" />
                  <circle cx="-25" cy="20" r="4" fill="#e0e7ff" />

                  <line
                    x1="-25"
                    y1="-10"
                    x2="-10"
                    y2="5"
                    stroke="#c7d2fe"
                    stroke-width="2"
                  />
                  <line
                    x1="-10"
                    y1="5"
                    x2="15"
                    y2="-5"
                    stroke="#c7d2fe"
                    stroke-width="2"
                  />
                  <line
                    x1="15"
                    y1="-5"
                    x2="25"
                    y2="15"
                    stroke="#c7d2fe"
                    stroke-width="2"
                  />
                  <line
                    x1="25"
                    y1="15"
                    x2="0"
                    y2="25"
                    stroke="#c7d2fe"
                    stroke-width="2"
                  />
                  <line
                    x1="0"
                    y1="25"
                    x2="-25"
                    y2="20"
                    stroke="#c7d2fe"
                    stroke-width="2"
                  />
                  <line
                    x1="-25"
                    y1="20"
                    x2="-10"
                    y2="5"
                    stroke="#c7d2fe"
                    stroke-width="2"
                  />
                </g>

                <g transform="translate(0, -10)">
                  <circle
                    cx="0"
                    cy="0"
                    r="35"
                    fill="none"
                    stroke-dasharray="3,3"
                    stroke="#60a5fa"
                    stroke-width="1"
                  >
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 0 0"
                      to="360 0 0"
                      dur="30s"
                      repeatCount="indefinite"
                    />
                  </circle>

                  <circle cx="0" cy="-35" r="3" fill="#ffffff">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 0 0"
                      to="360 0 0"
                      dur="5s"
                      repeatCount="indefinite"
                    />
                  </circle>

                  <circle cx="0" cy="-35" r="2" fill="#93c5fd">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="72 0 0"
                      to="432 0 0"
                      dur="7s"
                      repeatCount="indefinite"
                    />
                  </circle>

                  <circle cx="0" cy="-35" r="2" fill="#6366f1">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="144 0 0"
                      to="504 0 0"
                      dur="4s"
                      repeatCount="indefinite"
                    />
                  </circle>

                  <circle cx="0" cy="-35" r="3" fill="#ffffff">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="216 0 0"
                      to="576 0 0"
                      dur="6s"
                      repeatCount="indefinite"
                    />
                  </circle>

                  <circle cx="0" cy="-35" r="2" fill="#c7d2fe">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="288 0 0"
                      to="648 0 0"
                      dur="8s"
                      repeatCount="indefinite"
                    />
                  </circle>
                </g>

                <g class="binary-streams" opacity="0.7">
                  <text
                    x="-40"
                    y="-45"
                    font-family="monospace"
                    font-size="8"
                    fill="#60a5fa"
                  >
                    10110
                  </text>
                  <text
                    x="20"
                    y="-35"
                    font-family="monospace"
                    font-size="8"
                    fill="#60a5fa"
                  >
                    01001
                  </text>
                  <text
                    x="30"
                    y="-15"
                    font-family="monospace"
                    font-size="8"
                    fill="#60a5fa"
                  >
                    11010
                  </text>
                  <text
                    x="-45"
                    y="-20"
                    font-family="monospace"
                    font-size="8"
                    fill="#60a5fa"
                  >
                    00111
                  </text>
                  <text
                    x="25"
                    y="15"
                    font-family="monospace"
                    font-size="8"
                    fill="#60a5fa"
                  >
                    10010
                  </text>
                  <text
                    x="-40"
                    y="15"
                    font-family="monospace"
                    font-size="8"
                    fill="#60a5fa"
                  >
                    01101
                  </text>
                </g>

                <circle
                  cx="0"
                  cy="0"
                  r="60"
                  fill="url(#aidb-glow)"
                  opacity="0.5"
                >
                  <animate
                    attributeName="opacity"
                    values="0.3;0.5;0.3"
                    dur="3s"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="r"
                    values="60;65;60"
                    dur="6s"
                    repeatCount="indefinite"
                  />
                </circle>
              </g>

              <defs>
                <radialGradient
                  id="aidb-glow"
                  cx="0.5"
                  cy="0.5"
                  r="0.5"
                  fx="0.5"
                  fy="0.5"
                >
                  <stop offset="0%" stop-color="#c7d2fe" stop-opacity="0.6" />
                  <stop offset="40%" stop-color="#6366f1" stop-opacity="0.3" />
                  <stop offset="100%" stop-color="#2563eb" stop-opacity="0" />
                </radialGradient>
              </defs>

              <g transform="translate(400, 400)">
                <g transform="rotate(0)">
                  <g transform="translate(0, -240)">
                    <circle
                      cx="0"
                      cy="0"
                      r="50"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                    />
                    <path
                      d="M0,0 L33.33,0 A33.33,33.33 0 0,1 23.57,23.57 z"
                      fill="#e34c67"
                    />
                    <path
                      d="M0,0 L23.57,23.57 A33.33,33.33 0 0,1 -23.57,23.57 z"
                      fill="#ec6b85"
                    />
                    <path
                      d="M0,0 L-23.57,23.57 A33.33,33.33 0 0,1 -33.33,0 z"
                      fill="#f48ba5"
                    />
                    <path
                      d="M0,0 L-33.33,0 A33.33,33.33 0 0,1 0,-33.33 z"
                      fill="#f9b0c3"
                    />
                    <path
                      d="M0,0 L0,-33.33 A33.33,33.33 0 0,1 33.33,0 z"
                      fill="#fcd5e1"
                    />
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#e34c67"
                    >
                      Pie Chart
                    </text>
                  </g>
                </g>

                <g transform="rotate(45)">
                  <g transform="translate(0, -240)">
                    <rect
                      x="-50"
                      y="-50"
                      width="100"
                      height="100"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                      rx="5"
                      ry="5"
                    />
                    <rect
                      x="-40"
                      y="10"
                      width="15"
                      height="30"
                      fill="#35b779"
                      rx="2"
                      ry="2"
                    />
                    <rect
                      x="-20"
                      y="-10"
                      width="15"
                      height="50"
                      fill="#5dc998"
                      rx="2"
                      ry="2"
                    />
                    <rect
                      x="0"
                      y="-30"
                      width="15"
                      height="70"
                      fill="#86dcb8"
                      rx="2"
                      ry="2"
                    />
                    <rect
                      x="20"
                      y="15"
                      width="15"
                      height="25"
                      fill="#afecd6"
                      rx="2"
                      ry="2"
                    />
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#35b779"
                    >
                      Bar Chart
                    </text>
                  </g>
                </g>

                <g transform="rotate(90)">
                  <g transform="translate(0, -240)">
                    <rect
                      x="-50"
                      y="-50"
                      width="100"
                      height="100"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                      rx="5"
                      ry="5"
                    />
                    <polyline
                      points="-40,-10 -24,15 -8,-25 8,0 24,10 40,-15"
                      fill="none"
                      stroke="#440154"
                      stroke-width="3"
                      stroke-linejoin="round"
                      stroke-linecap="round"
                    />
                    <circle cx="-40" cy="-10" r="4" fill="#440154" />
                    <circle cx="-24" cy="15" r="4" fill="#440154" />
                    <circle cx="-8" cy="-25" r="4" fill="#440154" />
                    <circle cx="8" cy="0" r="4" fill="#440154" />
                    <circle cx="24" cy="10" r="4" fill="#440154" />
                    <circle cx="40" cy="-15" r="4" fill="#440154" />
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#440154"
                    >
                      Line Chart
                    </text>
                  </g>
                </g>

                <g transform="rotate(135)">
                  <g transform="translate(0, -240)">
                    <rect
                      x="-50"
                      y="-50"
                      width="100"
                      height="100"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                      rx="5"
                      ry="5"
                    />
                    <rect
                      x="-40"
                      y="-40"
                      width="80"
                      height="20"
                      fill="#ffa600"
                      rx="2"
                      ry="2"
                    />
                    <rect
                      x="-40"
                      y="-15"
                      width="80"
                      height="15"
                      fill="#ffca66"
                      rx="2"
                      ry="2"
                    />
                    <rect
                      x="-40"
                      y="5"
                      width="80"
                      height="15"
                      fill="#ffdb99"
                      rx="2"
                      ry="2"
                    />
                    <rect
                      x="-40"
                      y="25"
                      width="80"
                      height="15"
                      fill="#ffedcc"
                      rx="2"
                      ry="2"
                    />
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#ffa600"
                    >
                      Data Table
                    </text>
                  </g>
                </g>

                <g transform="rotate(180)">
                  <g transform="translate(0, -320)">
                    <circle
                      cx="0"
                      cy="0"
                      r="50"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                    />
                    <g transform="translate(0, 0)">
                      <rect
                        x="-25"
                        y="-25"
                        width="50"
                        height="40"
                        fill="#14b8a6"
                        rx="5"
                        ry="5"
                      />
                      <rect
                        x="-25"
                        y="-25"
                        width="50"
                        height="10"
                        fill="#0d9488"
                        rx="5"
                        ry="5"
                      />
                      <path
                        d="M-25,-15 L0,5 L25,-15"
                        fill="none"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M-18,-25 L0,-10 L18,-25"
                        fill="none"
                        stroke="white"
                        stroke-width="2"
                        stroke-linejoin="round"
                      />
                      <rect
                        x="-9"
                        y="15"
                        width="18"
                        height="6"
                        fill="#0d9488"
                        rx="2"
                        ry="2"
                      />
                    </g>
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#14b8a6"
                    >
                      Email Report
                    </text>
                  </g>
                </g>

                <g transform="rotate(225)">
                  <g transform="translate(0, -320)">
                    <circle
                      cx="0"
                      cy="0"
                      r="50"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                    />
                    <g transform="translate(0, 0)">
                      <circle cx="-18" cy="0" r="11" fill="#f97316" />
                      <circle cx="18" cy="0" r="11" fill="#f97316" />
                      <circle cx="0" cy="-25" r="14" fill="#f97316" />

                      <path
                        d="M0,-25 L-18,0"
                        stroke="#f97316"
                        stroke-width="7"
                      />
                      <path
                        d="M0,-25 L18,0"
                        stroke="#f97316"
                        stroke-width="7"
                      />
                      <path d="M-11,8 C-11,20 11,20 11,8" fill="#f97316" />

                      <rect
                        x="-4"
                        y="10"
                        width="8"
                        height="20"
                        rx="2"
                        ry="2"
                        fill="#f97316"
                      />
                    </g>
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#f97316"
                    >
                      Share
                    </text>
                  </g>
                </g>

                <g transform="rotate(270)">
                  <g transform="translate(0, -320)">
                    <circle
                      cx="0"
                      cy="0"
                      r="50"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                    />
                    <g transform="translate(0, 0)">
                      <circle
                        cx="0"
                        cy="0"
                        r="35"
                        fill="#fbcfe8"
                        opacity="0.5"
                      />
                      <path
                        d="M0,-20 L-20,5 L-8,5 L-8,20 L8,20 L8,5 L20,5 Z"
                        fill="#ec4899"
                      />
                      <circle cx="0" cy="0" r="5" fill="#be185d" />
                    </g>
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#ec4899"
                    >
                      Download
                    </text>
                  </g>
                </g>

                <g transform="rotate(315)">
                  <g transform="translate(0, -320)">
                    <circle
                      cx="0"
                      cy="0"
                      r="50"
                      fill="#f3f4f6"
                      stroke="#d1d5db"
                      stroke-width="2"
                    />
                    <g transform="translate(0, 0)">
                      <circle
                        cx="0"
                        cy="0"
                        r="30"
                        fill="none"
                        stroke="#8b5cf6"
                        stroke-width="5"
                      />
                      <circle cx="0" cy="0" r="3" fill="#8b5cf6" />

                      <line
                        x1="0"
                        y1="-30"
                        x2="0"
                        y2="-20"
                        stroke="#8b5cf6"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                      <line
                        x1="30"
                        y1="0"
                        x2="20"
                        y2="0"
                        stroke="#8b5cf6"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                      <line
                        x1="0"
                        y1="30"
                        x2="0"
                        y2="20"
                        stroke="#8b5cf6"
                        stroke-width="4"
                        stroke-linecap="round"
                      />
                      <line
                        x1="-30"
                        y1="0"
                        x2="-20"
                        y2="0"
                        stroke="#8b5cf6"
                        stroke-width="4"
                        stroke-linecap="round"
                      />

                      <line
                        x1="15"
                        y1="-26"
                        x2="10"
                        y2="-17"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                      <line
                        x1="26"
                        y1="-15"
                        x2="17"
                        y2="-10"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                      <line
                        x1="26"
                        y1="15"
                        x2="17"
                        y2="10"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                      <line
                        x1="15"
                        y1="26"
                        x2="10"
                        y2="17"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                      <line
                        x1="-15"
                        y1="26"
                        x2="-10"
                        y2="17"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                      <line
                        x1="-26"
                        y1="15"
                        x2="-17"
                        y2="10"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                      <line
                        x1="-26"
                        y1="-15"
                        x2="-17"
                        y2="-10"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />
                      <line
                        x1="-15"
                        y1="-26"
                        x2="-10"
                        y2="-17"
                        stroke="#8b5cf6"
                        stroke-width="3"
                        stroke-linecap="round"
                      />

                      <path
                        d="M0,0 L0,-15 L15,10"
                        fill="none"
                        stroke="#8b5cf6"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <text
                      x="0"
                      y="75"
                      text-anchor="middle"
                      font-family="Arial, sans-serif"
                      font-size="14"
                      font-weight="bold"
                      fill="#8b5cf6"
                    >
                      Schedule
                    </text>
                  </g>
                </g>
              </g>

              <g transform="translate(400, 400)">
                <circle
                  class="data-ball"
                  cx="190"
                  cy="-190"
                  r="8"
                  fill="#e34c67"
                >
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="3s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 0 0"
                    to="360 0 0"
                    dur="20s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle class="data-ball" cx="0" cy="-230" r="8" fill="#35b779">
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="45 0 0"
                    to="405 0 0"
                    dur="25s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle
                  class="data-ball"
                  cx="-190"
                  cy="-190"
                  r="8"
                  fill="#440154"
                >
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="4s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="90 0 0"
                    to="450 0 0"
                    dur="22s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle class="data-ball" cx="-230" cy="0" r="8" fill="#ffa600">
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="2.5s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="135 0 0"
                    to="495 0 0"
                    dur="18s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle
                  class="data-ball"
                  cx="-190"
                  cy="190"
                  r="8"
                  fill="#14b8a6"
                >
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="3.5s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="180 0 0"
                    to="540 0 0"
                    dur="28s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle class="data-ball" cx="0" cy="230" r="8" fill="#f97316">
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="4.5s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="225 0 0"
                    to="585 0 0"
                    dur="16s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle
                  class="data-ball"
                  cx="190"
                  cy="190"
                  r="8"
                  fill="#ec4899"
                >
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="270 0 0"
                    to="630 0 0"
                    dur="30s"
                    repeatCount="indefinite"
                  />
                </circle>

                <circle class="data-ball" cx="230" cy="0" r="8" fill="#8b5cf6">
                  <animate
                    attributeName="opacity"
                    values="0.6;1;0.6"
                    dur="3s"
                    repeatCount="indefinite"
                  />
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="315 0 0"
                    to="675 0 0"
                    dur="24s"
                    repeatCount="indefinite"
                  />
                </circle>
              </g>

              <text
                x="400"
                y="480"
                text-anchor="middle"
                font-family="Arial, sans-serif"
                font-size="18"
                font-weight="bold"
                fill="#3b82f6"
              >
                AI-Powered Insights
              </text>
            </svg>
          </div>

          <p className="text-green-500 font-semibold text-3xl">
            Welcome to TalkingData.AI
          </p>
          <p className="max-w-lg text-sm mt-3 mx-auto">
            We're happy to have you join the family. Please follow the next few
            steps to get your workspace set up for free.
          </p>
        </div>

        <div className="flex justify-end border-t border-gray-200 mt-4 py-6">
          <Button
            onClick={() => {
              setStep((prev) => prev + 1);
            }}
            className="px-12"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
